import makeStyles from '@mui/styles/makeStyles';
import { Button, Card, CardContent, CardHeader, Grid, Theme } from '@mui/material';
import { useApplicationsStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { PermissionsUtils, RoutePaths } from '@shared/utils';
import { PermissionLevel, PermissionType } from '@shared/types';
import { ApplicationSearchForm, ApplicationsTable } from './widgets';
import { DelayedLinearProgress } from '@shared/widgets';

const useStyles = makeStyles<Theme>((theme) => ({
  headerContainer: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    textAlign: 'center',
  },
  button: {
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
  },
}));

export const ApplicationsPage = () => {
  const { navigate } = useRouteHook();

  const { loading, data: applications } = useApplicationsStore();

  const classes = useStyles();

  const canCreate = PermissionsUtils.hasPermission(PermissionType.APPLICATIONS, PermissionLevel.WRITE);
  return (
    <Grid container alignContent='center'>
      <Grid item xs={12} md={3} xl={2}>
        <Card>
          <CardHeader title='Filter Applications' />
          <CardContent style={{ paddingTop: 0 }}>
            <ApplicationSearchForm />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={9} xl={10}>
        <Card>
          <DelayedLinearProgress loading={loading} />
          <div className={classes.headerContainer}>
            <CardHeader title='Applications' />
            {canCreate && (
              <Button
                variant='contained'
                color='primary'
                className={classes.button}
                onClick={() => navigate(RoutePaths.applicationsNew.onNavigate())}
              >
                Create New Application
              </Button>
            )}
          </div>
          {applications && <ApplicationsTable loading={loading} data={applications} />}
        </Card>
      </Grid>
    </Grid>
  );
};
